<template>
  <div>
    <ots-main-title></ots-main-title>

    <div class="config-section">
      <div class="section-title">远程操控检测参数</div>
      <div class="section-desc">
        远程操控检测每{{ form.remoteCheckCycle }}秒，捕获{{ form.remoteCatchTimes }}次。
      </div>
      <el-form ref="form" :model="form" class="config-form">
        <el-form-item label="检测周期（秒）">
          <el-select v-model="form.remoteCheckCycle">
            <el-option
              v-for="item in cycleOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="捕获次数（次）">
          <el-select v-model="form.remoteCatchTimes">
            <el-option
              v-for="item in timesOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" round @click="handleSave">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getExamConfigBaseAPI, saveExamConfigBaseAPI } from "@/http/modules/computedRoomExam";

export default {
  data() {
    return {
      cycleOptions: [5, 10, 15, 20, 25, 30],
      timesOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      form: {
        id: '',
        remoteCheckCycle: 10,
        remoteCatchTimes: 6,
      },
    };
  },
  created() {
    this.getConfig();
  },
  methods: {
    async getConfig() {
      const { data } = await getExamConfigBaseAPI();
      if (data) {
        this.form.id = data.id;
        this.form.remoteCheckCycle = data.remoteCheckCycle;
        this.form.remoteCatchTimes = data.remoteCatchTimes;
      }
    },
    async handleSave() {
      const params = {
        id: this.form.id,
        remoteCheckCycle: this.form.remoteCheckCycle,
        remoteCatchTimes: this.form.remoteCatchTimes,
      };
      const { code } = await saveExamConfigBaseAPI(params);
      if (code === 1) {
        this.$message.success("保存成功！");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.config-section {
  margin-top: 20px;
  padding: 24px;
  background: #fff;
  border-radius: 4px;

  .section-title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 12px;
  }

  .section-desc {
    font-size: 14px;
    color: #606266;
    margin-bottom: 20px;
  }

  .config-form {
    /deep/ .el-form-item__label {
      width: 140px;
    }

    /deep/ .el-form-item {
      display: flex;
      align-items: center;
    }

    /deep/ .el-select {
      width: 120px;
    }
  }
}
</style>
